import type { LayoutLoad } from "./$types";

export const load: LayoutLoad = () => {
  return {
    ogTitle: "Modal",
  };
};
